// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar[data-v-79711a16]{margin-left:10px;margin-right:10px}.img[data-v-79711a16]{width:26px}.ankeri-logo[data-v-79711a16]{width:100px}.v-container[data-v-79711a16]{max-width:1344px!important}.ai-btn:hover .ai-icon[data-v-79711a16]{color:rgb(var(--v-theme-primary))!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
